// extracted by mini-css-extract-plugin
export default {"table":"ExpandedRowTable_table__SR0mj"};